import { useMemo } from 'react';
import { useTable, usePagination, useGlobalFilter } from 'react-table';

import TableSearch from './TableSearch';
import TablePagination from './TablePagination';

function RemittanceWalletsTable(props) {
    let columns = useMemo(() => props.columns, [props.columns])
    let data = useMemo(() => props.data, [props.data])

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        state: { pageIndex, globalFilter },

        gotoPage,
        pageOptions,
        preGlobalFilteredRows,
        setGlobalFilter
    } = useTable(
        {
            columns,
            data,
            initialState: { pageSize: 10, pageIndex: 0 }
        },
        useGlobalFilter,
        usePagination

    )

    function changePage(e) {
        gotoPage(e - 1);
    }

    return (
        <div>
            <div className="table-wrapper">
                <div className="d-flex justify-content-center">
                    <TableSearch
                        preGlobalFilteredRows={preGlobalFilteredRows}
                        globalFilter={globalFilter}
                        setGlobalFilter={setGlobalFilter}
                    />
                </div>
                <br />
                <table {...getTableProps()}>
                    <thead>
                        {
                            headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {
                                        headerGroup.headers.map(column => (
                                            <th style={{ textAlign: "left" }} {...column.getHeaderProps()}>{column.render('Header')}</th>
                                        ))
                                    }
                                </tr>
                            ))
                        }
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {
                            page.map((row, i) => {
                                prepareRow(row)
                                return (
                                    <tr {...row.getRowProps()}>
                                        {
                                            row.cells.map(cell => {
                                                return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                            })
                                        }
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
            <div className="mt-3 d-flex justify-content-center">
                <TablePagination current={pageIndex + 1} total={pageOptions.length} changePage={changePage} />
            </div>
        </div>
    )
}

export default RemittanceWalletsTable;